import { render, staticRenderFns } from "./ReallocateHours.vue?vue&type=template&id=6b81b37a&scoped=true&"
import script from "./ReallocateHours.vue?vue&type=script&lang=js&"
export * from "./ReallocateHours.vue?vue&type=script&lang=js&"
import style0 from "./ReallocateHours.vue?vue&type=style&index=0&id=6b81b37a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b81b37a",
  null
  
)

export default component.exports